var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex-column flex-grow-1 overflow-hidden",
      class: { "d-none": _vm.hidden, "d-flex": !_vm.hidden },
      staticStyle: { height: "100%", position: "relative" },
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.onChatDragOver.apply(null, arguments)
        },
        dragleave: _vm.onChatDragLeave,
        drop: function ($event) {
          $event.preventDefault()
          return _vm.onChatDrop.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "messages",
          staticClass: "flex-grow-1 card mb-2 overflow-auto",
          attrs: { id: "ai-chat-messages" },
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _vm.messages.length
              ? _c(
                  "div",
                  _vm._l(_vm.messages, function (message, index) {
                    return _c("AIChatMessage", {
                      key: index,
                      attrs: {
                        index: index,
                        message: message,
                        "is-last": index === _vm.messages.length - 1,
                      },
                      on: {
                        "select-product": _vm.selectProduct,
                        "copy-proof-link": _vm.copyProofLink,
                        "duplicate-template-and-prepare-resized-data":
                          _vm.duplicateTemplateAndPrepareResizeData,
                        "select-product-option": function ($event) {
                          return _vm.selectProductOption($event, message)
                        },
                        "open-product-selector": function ($event) {
                          return _vm.openProductSelector($event)
                        },
                        "widget-action": _vm.handleWidgetAction,
                        "widget-sequence-confirm": _vm.handleSequenceConfirm,
                        "save-to-clipboard": _vm.onSaveMessageToClipboard,
                      },
                    })
                  }),
                  1
                )
              : _c("div", [
                  _c("div", { staticClass: "welcome-message" }, [
                    _c("div", { staticClass: "message__author" }, [
                      _c("svg", [
                        _c("use", {
                          attrs: {
                            width: "14",
                            height: "14",
                            href: "/img/icons/bot.svg#icon-bot",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "separator" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ai-chat-suggestions d-flex justify-content-center pb-0",
        },
        _vm._l(_vm.suggestions, function (suggestion) {
          return _c(
            "button",
            {
              key: suggestion,
              staticClass: "ai-chat-suggestions__bubble",
              on: {
                click: function ($event) {
                  return _vm.setSuggestion(suggestion)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(suggestion) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "mt-2 d-flex justify-content-center align-items-center gap-2",
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-stop-ai",
                  attrs: { title: "Stop" },
                  on: { click: _vm.stopCurrentProcess },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "2",
                          y: "2",
                          width: "10",
                          height: "10",
                          rx: "2",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pendingPdpRegeneration
        ? _c("div", { staticClass: "ai-chat-regen-banner" }, [
            _c("span", [
              _vm._v("\n      Describe the changes for "),
              _c("b", [_vm._v(_vm._s(_vm.pendingPdpRegeneration.label))]),
              _vm._v(", then press Enter.\n    "),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ai-chat-regen-banner__cancel",
                attrs: { type: "button" },
                on: { click: _vm.cancelPdpRegeneration },
              },
              [_vm._v("\n      Cancel\n    ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("AIChatTextArea", {
        ref: "chatTextArea",
        attrs: { files: _vm.userFiles, disabled: _vm.loading },
        on: {
          "update:files": function ($event) {
            _vm.userFiles = $event
          },
          "update:prompt": function ($event) {
            _vm.userInput = $event
          },
          "handle-enter-key": _vm.handleEnterKey,
          "send-message": function ($event) {
            return _vm.sendMessage($event.text, $event.files)
          },
        },
      }),
      _vm._v(" "),
      _c("SelectFolderModal", {
        attrs: {
          mode: _vm.selectFolderModalState.mode,
          "view-tabs": _vm.selectFolderModalState.viewTabs,
          "modal-title": _vm.selectFolderModalState.modalTitle,
        },
        on: { onSelectedItems: _vm.onAiChatFolderItemsSelected },
      }),
      _vm._v(" "),
      _vm.isChatDragover
        ? _c("div", { staticClass: "ai-chat-tab-drop-overlay" }, [
            _c("div", { staticClass: "ai-chat-tab-drop-overlay__inner" }, [
              _vm._v("\n      Drop images to attach\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ClipboardSavedToast", { ref: "clipboardSavedToast" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "welcome-message__content" }, [
      _c("p", [
        _vm._v("Hi! I'm Optix AI - your layout assistant."),
        _c("br"),
        _vm._v(
          "Ask me for copy improvements, hierarchy tweaks, or layer cleanup ideas."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thinking-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }